var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget"},_vm._l((Object.keys(_vm.data)),function(key){return _c('div',{key:key,staticClass:"ratetag"},[_vm._v(" "+_vm._s(key)+" - "+_vm._s(_vm.data[key])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }